import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../api/api";
import { getPracticeId } from "../../../../config/practice";

const StopBangLink = () => {
  const { patientid, filename } = useParams();
  const [loading, setLoading] = useState(true);
  const [json, setJson] = useState(null);

  const practiseid = getPracticeId();
  const SCREENSHOT_TARGET_ID = "screenshot-ready-container";

  useEffect(() => {
    const fetchHtml = async () => {
      try {
        const response = await api.get(
          `/v1/${practiseid}/pcard/${patientid}/formHistory/${filename}`
        );
        if (response.status === 200) setJson(response.data?.json_data || null);
      } catch (err) {
        console.log(err);
      } finally {
        setTimeout(() => setLoading(false), 300);
      }
    };

    fetchHtml();
  }, [filename]);

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen text-xl font-semibold">
        Loading...
      </div>
    );

  if (!json)
    return (
      <div className="flex items-center justify-center h-screen text-xl text-red-600">
        No Data Found
      </div>
    );

  // -------------------------------------------------------------------------------------

  const stopQuestions = [
    { q: "Do you SNORE loudly (louder than talking or loud enough to be heard through closed doors)?", key: "qanswer_1_1" },
    { q: "Do you often feel TIRED, fatigue, or sleepy during daytime?", key: "qanswer_1_2" },
    { q: "Has anyone OBSERVED you stop breathing during your sleep?", key: "qanswer_1_3" },
    { q: "Do you have or are you being treated for high blood PRESSURE?", key: "qanswer_1_4" },
  ];

  const bangQuestions = [
    { q: "BMI more than 35 kg/m²?", key: "qanswer_1_5" },
    { q: "AGE over 50 years old?", key: "qanswer_1_6" },
    { q: "NECK circumference > 16 inches (40 cm)?", key: "qanswer_1_7" },
    { q: "GENDER: Male?", key: "qanswer_1_8" },
  ];

  const renderYesNo = (value) => (
    <div className="flex space-x-4 mt-2">
      {["YES", "NO"].map((opt) => (
        <span
          key={opt}
          className={`px-4 py-2 rounded-full text-sm font-sans border ${
            json[value] === opt
              ? "bg-blue-600 text-white border-blue-600"
              : "bg-white border-gray-300 text-black"
          }`}
        >
          {opt}
        </span>
      ))}
    </div>
  );

  // -------------------------------------------------------------------------------------

  return (
    <>
    

      <div id={json.patient_name?SCREENSHOT_TARGET_ID:undefined} className="min-h-screen bg-[#f7f7f7] flex justify-center py-10 px-3">
        <div className="bg-white text-start shadow-lg rounded-lg p-6 max-w-4xl w-full">

          {/* Header */}
          <h2 className="text-2xl font-bold mb-4">{json.form_name}</h2>

          {/* Reference / Notes */}
          <p className="text-gray-700 mb-4">
            Chung F et al. Anesthesiology 2008; British Journal of Anaesthesia 2012.
          </p>

          {/* STOP Section */}
          <h3 className="font-bold text-xl mt-4 mb-2">STOP</h3>
          {stopQuestions.map((q, idx) => (
            <div key={idx} className="mb-4">
              <label className="font-bold text-base">{q.q}</label>
              {renderYesNo(q.key)}
            </div>
          ))}

          {/* BANG Section */}
          <h3 className="font-bold text-xl mt-4 mb-2">BANG</h3>
          {bangQuestions.map((q, idx) => (
            <div key={idx} className="mb-4">
              <label className="font-bold text-base">{q.q}</label>
              {renderYesNo(q.key)}
            </div>
          ))}

          {/* Total Score */}
          <div className="mt-6 p-4 bg-gray-100 border-l-4 border-blue-600 rounded-md text-gray-800">
            <p className="font-semibold">Total Score: {json.total_score}</p>
            <p className="mt-2">
              High Risk of OSA: 5–8 <br />
              Intermediate Risk: 3–4 <br />
              Low Risk: 0–2
            </p>
          </div>

        </div>
      </div>
    </>
  );
};

export default StopBangLink;
